export const replaceUnderscoreWithTo = (inputString) => {
  return inputString?.replace('_', ' To ');
};
